import { Spinner } from 'design-system';

export interface GlobalLoaderProps {
  open: boolean;
  message?: string;
}

export const GlobalLoader = ({ open, message }: GlobalLoaderProps) => {
  if (!open) {
    return null;
  }

  return (
    <output
      aria-busy='true'
      aria-live='polite'
      className='fixed inset-0 z-[var(--z-loading-backdrop)] flex flex-col items-center justify-center gap-4 bg-background'
    >
      <Spinner className='size-10' />
      {message && <p className='text-sm'>{message}</p>}
    </output>
  );
};
